// @ts-nocheck
import { PLAY_STATES } from '@amp/web-app-components/src/constants';

// Platter Icons
import PlayPlatterIcon from '@amp/web-app-components/assets/icons/play-button/platter/play-alias.svg';
import PausePlatterIcon from '@amp/web-app-components/assets/icons/play-button/platter/pause-circle-fill.svg';
// NonPlatter Icons
import PlayIcon from '@amp/web-app-components/assets/icons/play-button/non-platter/play.svg';
import PauseIcon from '@amp/web-app-components/assets/icons/play-button/non-platter/pause.svg';
import BufferIcon from '@amp/web-app-components/assets/icons/play-button/non-platter/buffer.svg';
// Progress Icons
import PlayProgressIcon from '@amp/web-app-components/assets/icons/play-button/progress/play-progress.svg';
import PauseProgressIcon from '@amp/web-app-components/assets/icons/play-button/progress/pause-progress.svg';
import BufferProgressIcon from '@amp/web-app-components/assets/icons/play-button/progress/buffer-progress.svg';

import type { SvelteComponent } from 'svelte';
import type { ValueOf } from '@amp/web-app-components/src/types';

export const PLAY_ICON_SETS = {
    PLATTER: 'platter',
    NON_PLATTER: 'non-platter',
    RADIAL_PROGRESS: 'radial-progress',
} as const;

export type IconState = ValueOf<typeof PLAY_STATES>;
export type PlayIconSet = ValueOf<typeof PLAY_ICON_SETS>;

export type IconStateCollection = Record<
    IconState,
    new (...args: any[]) => SvelteComponent | null
>;

export type IconMapping = Record<PlayIconSet, IconStateCollection>;

const { PLAY, PAUSE, BUFFER, PLAYING } = PLAY_STATES;
const { PLATTER, NON_PLATTER, RADIAL_PROGRESS } = PLAY_ICON_SETS;

export const iconStateComponentIconMapping: IconMapping = {
    [PLATTER]: {
        [PLAY]: PlayPlatterIcon,
        [PAUSE]: PausePlatterIcon,
        [BUFFER]: BufferIcon,
        [PLAYING]: PausePlatterIcon,
    },
    [NON_PLATTER]: {
        [PLAY]: PlayIcon,
        [PAUSE]: PauseIcon,
        [BUFFER]: BufferIcon,
        [PLAYING]: PauseIcon,
    },
    [RADIAL_PROGRESS]: {
        [PLAY]: PlayIcon,
        [PAUSE]: PauseProgressIcon,
        [BUFFER]: BufferProgressIcon,
        [PLAYING]: PlayProgressIcon,
    },
};

export interface SVGOptions {
    width?: string;
    height?: string;
    viewBox?: string;
}
